import {
    checkRevisionUrl,
    getThumbnailUrl,
    policiesUrl,
    saveImageAndDocumentUrl,
    saveToMediaUrl,
    signDocumentV3Url
} from "./EndpointService.js";
import {API_METHODS, apiFetch, policyApiFetch, policyApiUpload} from "./ApiService.js";

export const getDocuments = async (token_arg) => {
    let url = `${policiesUrl}?toreturn=true`;

    try {
        return await policyApiFetch(`${url}&per_page=1`, token_arg).then(async (response) => {
            return await policyApiFetch(`${url}&per_page=${response.total !== 0 ? response.total : 1}`, token_arg)
        });
    } catch (error) {
        return null;
    }
};

export const countDocument = async (token_arg) => {
    let url = `${policiesUrl}?toreturn=true`;

    try {
        return await policyApiFetch(`${url}&per_page=1`, token_arg);
    } catch (error) {
        return null;
    }
};

export const checkRevision = async (token_arg, body) => {
    let url = `${checkRevisionUrl}`;
    try {
        return await apiFetch(url, token_arg, API_METHODS.POST, body);
    } catch (error) {
        return null;
    }
};

export const getTitleDocument = async (token_arg, policyId, titleId, type) => {
    let url = `${policiesUrl}/${policyId}/titles/${titleId}/document?doctype=${type}`;
    try {
        return await policyApiFetch(url, token_arg);
    } catch (error) {
        return null;
    }
};

export const getSigningThumbnail = async (token_arg, id) => {
    const body = {id: id, type: "expectedDocument"};
    try {
        return await apiFetch(getThumbnailUrl, token_arg, API_METHODS.POST, body);
    } catch (error) {
        return null;
    }
};

export const saveToMedia = async (token_arg, id) => {
    try {
        return await apiFetch(`${saveToMediaUrl}/${id}`, token_arg, API_METHODS.POST);
    } catch (error) {
        return null;
    }
};

export const uploadOrSignDocument = async (token_arg, policyId, titleId, type, contentType, body) => {
    try {
        return await policyApiUpload(`${policiesUrl}/${policyId}/titles/${titleId}/document_customer_signed?firma_digitale=${type}`, token_arg, contentType, body);
    } catch (error) {
        return null;
    }
};

export const signDocumentV3 = async (token_arg, body) => {
    try {
        return await apiFetch(`${signDocumentV3Url}`, token_arg, API_METHODS.POST, body);
    } catch (error) {
        return null;
    }
};

export const saveImageAndDocument = async (token_arg, body) => {
    try {
        return await apiFetch(`${saveImageAndDocumentUrl}`, token_arg, API_METHODS.POST, body);
    } catch (error) {
        return null;
    }
};
